module.exports = __webpack_public_path__ + "static/media/eldenring.5c7142e1.png";